<template>
  <div
    class="p-6 btn-radius relative w-full section-bg-color"
    :style="[customCss]"
  >
    <div
      class="section-content-color text-base text-dark font-semibold"
      v-if="label"
    >
      {{ label }}
    </div>
    <div class="canvas-progress-bar w-full">
      <div
        class="progress-bar-uncompleted rounded-md btn-radius overflow-hidden mt-3"
      >
        <div
          class="rounded-md w-0 h-3 progress-bar-completed"
          :style="{ width: `${progress}%` }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    label: {
      default: () => null,
    },
    completed: {
      default: () => 0,
    },
    total: {
      default: () => 1,
    },
    getThemeSettings: {},
  },
  computed: {
    progress() {
      return (this.completed / this.total) * 100;
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--section-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
        '--section-content-color': this.themeSettings.configuration_options
          .section_content_color,
        '--progress-bar-completed-color': this.themeSettings.progressbar_section
          .complete_bar_color,
        '--progress-bar-uncompleted-color': this.themeSettings
          .progressbar_section.uncomplete_bar_color,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.section-bg-color {
  background: var(--section-bg-color);
}
.section-content-color {
  color: var(--section-content-color);
}
.progress-bar-completed {
  background-color: var(--progress-bar-completed-color);
}
.progress-bar-uncompleted {
  background-color: var(--progress-bar-uncompleted-color);
}
.canvas-progress-bar .h-3 {
  height: 10px;
}
</style>
